import styled from 'styled-components';
import ContentEditable from 'react-contenteditable';
import {
  Link,
} from 'react-router-dom';

import {
  Flex,
} from 'web-styled';

export const Item = styled(Flex).attrs({
  shrink: 0,
  column: true,
})`
  margin: 0;
  width: 100%;
  padding: 10px 15px;
  border-bottom: 1px solid #ededed;

  & .is_hover_only {
    visibility: hidden;
  }

  &:hover {
    background: #fbfbfb;

    & .is_hover_only {
      visibility: visible;
    }
  }

  &.blinker {
    animation: 1s blinker 1.5s linear;
  }

  @keyframes blinker {
    0% {
      background-color: #f5f5f5;
    }
    20% {
      background-color: white;
    }
    40% {
      background-color: #f5f5f5;
    }
    60% {
      background-color: white;
    }
    80% {
      background-color: #f5f5f5;
    }
    100% {
      background-color: white;
    }
  }
`;

export const Name = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  // white-space: nowrap;
  overflow: hidden;
  padding: 5px;
  margin-left: -5px;
  text-overflow: ellipsis;
  border: 1px dashed transparent;
  color: ${props => props.theme.colors.link};
  font-size: 14px;
  line-height: 28px;

  & > div {
    margin-right: 8px;
  }
`;

export const EditableWrapper = styled(Flex).attrs({
  align: 'center',
  content: 'center',
  spacing: 8,
})`
  color: ${props => props.theme.colors.inputColor};
  font-size: 14px;
  padding: 5px 5px;
  margin-left: -5px;
  border: 1px dashed ${props => props.theme.colors.primary};
  border-radius: 5px;
  outline: none;
`;

export const EditableName = styled(ContentEditable)`
  color: ${props => props.theme.colors.inputColor};
  font-size: 14px;
  line-height: 28px;
  outline: none;
`;

export const Time = styled.span`
  color: #404447;
  font-size: 14px;
  line-height: 30px;
  width: 100px;
  text-align: right;
`;

export const Empty = styled(Flex).attrs({
  column: true,
  spacing: 10,
  align: 'center',
  justify: 'center',
})`
  width: 100%;
  height: 100%;
  color: #ccc;
  text-align: center;
`;
